export default class ChangePositions {

    constructor() {
        this.onResizeBind = this.onResize.bind( this );
        this.elements = document.querySelectorAll( '[data-change-position]' );
        this.breakpoint = 991;
        this.onResize();
        this.events();
    }

    onResize() {
        Array.from(this.elements).forEach( div => {
            let target = document.querySelector(  div.dataset.target );
            if( ! target ) return;

            if ( window.innerWidth <= ( div.dataset.breakpoint || this.breakpoint ) ) {
                if( ! target.children.length ) {
                    this.moveChildren( div, target );
                }
            }
            else if( ! div.children.length ) {
                    this.moveChildren( target, div );
            }
        } );
    }

    moveChildren( element, target ){
		Array.from(element.children).forEach(element => target.appendChild( element ) );
    }

	events() {
		window.addEventListener( 'resize', this.onResizeBind );
	}


    destroy() {
        window.removeEventListener( 'onresize', this.onResizeBind );
    }

}
